import { render, staticRenderFns } from "./demandPredict.vue?vue&type=template&id=bc58f9f6&scoped=true"
import script from "./demandPredict.vue?vue&type=script&lang=js"
export * from "./demandPredict.vue?vue&type=script&lang=js"
import style0 from "./demandPredict.vue?vue&type=style&index=0&id=bc58f9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc58f9f6",
  null
  
)

export default component.exports